import { Stack } from '@chakra-ui/react'
import { InputFormControl, SwitchFormControl } from 'BrokerTsLib/src/components'
import type { EditOrganizationUnit } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormSection } from '@/containers/forms/FormSection'
import { Insurer } from 'BrokerTsLib/src/enums'
import { useGetAvailableInsurers } from 'BrokerTsLib/src/hooks/useOrganizationUnit'

export const OrganizationVehicleLeasingInsuranceFormSection = forwardRef(
  function OrganizationVehicleLeasingInsuranceFormSection(props: FormSectionProps, ref: Ref<HTMLDivElement>) {
    const { control, watch } = useFormContext<EditOrganizationUnit>()

    const ouId = watch('id')
    const superiorOuId = watch('superiorOrganizationUnitId')
    const { data } = useGetAvailableInsurers(ouId ?? superiorOuId)
    const isGcpAllowed = data?.data?.some(insurer => insurer.insurerId === Insurer.GeneraliCeskaPojistovna)

    const isGcpHomeServiceAllowed = watch('properties.allowGcpHomeService')
    return <FormSection ref={ref} sectionTitle='Nastavení pojištění vozidel' {...props}>
      <Stack gap={6}>
        {isGcpAllowed && <>
          <SwitchFormControl name='properties.allowGcpHomeService' control={control} label="Povolit Domovský servis GČP" />
          {isGcpHomeServiceAllowed &&
            <InputFormControl name='properties.gcpHomeServiceIds' control={control} label="ID Domovského servisu GČP"
              helperText="Zadávejte kód z číselníku GČP ve formátu <HS_ID>|<HS_SEQ_NO>"
            />
          }
        </>
        }
      </Stack>
    </FormSection>
  }
)